import { createContext, useContext, ReactNode, useState } from "react";
import en from "../config/localization/en";
import id from "../config/localization/id";
import { getLanguage } from "../core/persistence/LocalStorage";

type TranslationContextValue = {
  t: (key: string) => string;
  setCurrentLanguage: React.Dispatch<React.SetStateAction<string>>;
};

export const TranslationContext = createContext<TranslationContextValue>({
  t: (key: string) => key as string,
  setCurrentLanguage: () => {},
});

export function TranslationProvider({ children }: { children: ReactNode }) {
  const lang = getLanguage() as string;
  const [currentLanguage, setCurrentLanguage] = useState<string>(lang);
  const translations: any = currentLanguage === "en" ? en : id;

  function t(key: string) {
    if (!key) return;
    return translations[key];
  }

  return (
    <TranslationContext.Provider value={{ t, setCurrentLanguage }}>
      {children}
    </TranslationContext.Provider>
  );
}

export function useTranslation() {
  const { t, setCurrentLanguage } = useContext(TranslationContext);
  return { t, setCurrentLanguage };
}
